import { combineReducers } from "redux";
import ApparelReducerState from "./apparelReducer";
const RootReducer = combineReducers({
    ApparelReducerState
});
 
export default RootReducer;